import * as actionLabels from "../../actionLabels";
export const getViewTeaSoldIdAction = (ViewTeaId) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD,
    payload: ViewTeaId,
  };
};

export const getViewTeaSoldByIdActionSuccess = (TeaSoldData) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD_SUCCESS,
    payload: TeaSoldData,
  };
};

export const getViewTeaSoldIdActionFail = (error) => ({
  type: actionLabels.GET_VIEW_TEA_SOLD_FAIL,
  payload: error,
});

export const getViewTeaSoldByLotIdAction = (LotId) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD_LOT,
    payload: LotId,
  };
};

export const getViewTeaSoldByLotIdActionSuccess = (LotData) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD_LOT_SUCCES,
    payload: LotData,
  };
};

export const getViewTeaSoldByLotIdActionFail = (error) => ({
  type: actionLabels.GET_VIEW_TEA_SOLD_LOT_FAIL,
  payload: error,
});

export const getViewTeaSoldMarketIdAction = (MarketId) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD_LOT_MARKET,
    payload: MarketId,
  };
};

export const getViewTeaSoldMarketByIdActionSuccess = (MarketData) => {
  return {
    type: actionLabels.GET_VIEW_TEA_SOLD_LOT_MARKET_SUCCES,
    payload: MarketData,
  };
};

export const getViewTeaSoldMarketIdActionFail = (error) => ({
  type: actionLabels.GET_VIEW_TEA_SOLD_LOT_MARKET_FAIL,
  payload: error,
});

export const getauctioneerIdAction = (auctioneerId) => {
  return {
    type: actionLabels.GET_VIEW_TEA_AUCTIONEER,
    payload: auctioneerId,
  };
};

export const getauctioneerByIdActionSuccess = (auctioneerData) => {
  return {
    type: actionLabels.GET_VIEW_TEA_AUCTIONEER_SUCCES,
    payload: auctioneerData,
  };
};

export const getauctioneerIdActionFail = (error) => ({
  type: actionLabels.GET_VIEW_TEA_AUCTIONEER_FAIL,
  payload: error,
});

export const getviewmarketsummaryIdAction = (marketsummaryId) => {
  return {
    type: actionLabels.GET_VIEW_MARKET_SUMMARY,
    payload: marketsummaryId,
  };
};

export const getviewmarketsummaryByIdActionSuccess = (summaryData) => {
  return {
    type: actionLabels.GET_VIEW_MARKET_SUMMARY_SUCCES,
    payload: summaryData,
  };
};

export const getviewmarketsummaryIdActionFail = (error) => ({
  type: actionLabels.GET_VIEW_MARKET_SUMMARY_FAIL,
  payload: error,
});

export const getMyplannerIdAction = (plannerId) => {
  return {
    type: actionLabels.GET_MY_PLANNER_ENG,
    payload: plannerId,
  };
};

export const getMyplannerActionSuccess = (plannerData) => {
  return {
    type: actionLabels.GET_MY_PLANNER_ENG_SUCCES,
    payload: plannerData,
  };
};

export const getMyplannerIdActionFail = (error) => ({
  type: actionLabels.GET_MY_PLANNER_ENG_FAIL,
  payload: error,
});

export const MyCatalogViewIdAction = (CatalogId) => {
  return {
    type: actionLabels.GET_MY_CATALOG_VIEW,
    payload: CatalogId,
  };
};

export const MyCatalogViewActionSuccess = (CatalogData) => {
  return {
    type: actionLabels.GET_MY_CATALOG_VIEW_SUCCES,
    payload: CatalogData,
  };
};

export const MyCatalogViewIdActionFail = (error) => ({
  type: actionLabels.GET_MY_CATALOG_VIEW_FAIL,
  payload: error,
});

export const MyCatalogViewLoading = () => ({
  type: actionLabels.GET_MY_CATALOG_VIEW_LOADING,
});

export const MyPlannerViewLoading = () => ({
  type: actionLabels.GET_MY_PLANNER_VIEW_LOADING,
});

export const MyViewMarketSummaryViewLoading = () => ({
  type: actionLabels.GET_MY_VIEW_MARKET_VIEW_LOADING,
});
export const MyViewTeaSoldMarketViewLoading = () => ({
  type: actionLabels.GET_MY_VIEW_TEA_SOLD_VIEW_LOADING,
});
export const MyViewTeaSoldViewLoading = () => ({
  type: actionLabels.GET_MY_VIEW_TEA_VIEW_LOADING,
});
export const MyViewTeaSoldByLotViewLoading = () => ({
  type: actionLabels.GET_MY_VIEW_TEA_LOT_VIEW_LOADING,
});
export const MyAuctioneerViewLoading = () => ({
  type: actionLabels.GET_MY_AUCTIONEER_VIEW_LOADING,
});
export const MyMarketDepthLoading = () => ({
  type: actionLabels.GET_MY_MARKET_DEPTH_VIEW_LOADING,
});

export const AddMyCatalogAction = (CatalogId) => {
  return {
    type: actionLabels.GET_MY_CATALOG_ADD,
    payload: CatalogId,
  };
};

export const AddMyCatalogActionSuccess = (CatalogData) => {
  return {
    type: actionLabels.GET_MY_CATALOG_ADD_SUCCES,
    payload: CatalogData,
  };
};

export const AddMyCatalogActionFail = (error) => ({
  type: actionLabels.GET_MY_CATALOG_ADD_FAIL,
  payload: error,
});

export const RemoveMyCatalogAction = (CatalogId) => {
  return {
    type: actionLabels.GET_MY_CATALOG_REMOVE,
    payload: CatalogId,
  };
};

export const RemoveMyCatalogActionSuccess = (CatalogData) => {
  return {
    type: actionLabels.GET_MY_CATALOG_REMOVE_SUCCES,
    payload: CatalogData,
  };
};

export const RemoveMyCatalogActionFail = (error) => ({
  type: actionLabels.GET_MY_CATALOG_REMOVE_FAIL,
  payload: error,
});

export const MyCatalogStutas = (data) => {
  return {
    type: actionLabels.GET_MY_CATALOG_STUTAS,
    payload: { data: data },
  };
};

export const ChangeReservePriceAction = (ReservePriceId) => {
  return {
    type: actionLabels.CHANGE_RESERVE_PRICE,
    payload: ReservePriceId,
  };
};

export const ChangeReservePriceActionSuccess = (ReservePriceData) => {
  return {
    type: actionLabels.CHANGE_RESERVE_PRICE_SUCCES,
    payload: ReservePriceData,
  };
};

export const ChangeReservePriceActionFail = (error) => ({
  type: actionLabels.CHANGE_RESERVE_PRICE_FAIL,
  payload: error,
});

export const AddMyCatalogStutas = (data) => {
  return {
    type: actionLabels.ADD_MY_CATALOG_STUTAS,
    payload: { data: data },
  };
};

export const RemoveMyCatalogStutas = (data) => {
  return {
    type: actionLabels.REMOVE_MY_CATALOG_STUTAS,
    payload: { data: data },
  };
};

export const ChangeReservePriceStutas = (data) => {
  return {
    type: actionLabels.CHANGE_PRICE_STUTAS,
    payload: { data: data },
  };
};

export const getMarketDepthIdAction = (MarketDepthId) => {
  return {
    type: actionLabels.GET_MARKET_DEPTH,
    payload: MarketDepthId,
  };
};

export const getMarketDepthActionSuccess = (MarketDepthData) => {
  return {
    type: actionLabels.GET_MARKET_DEPTH_SUCCES,
    payload: MarketDepthData,
  };
};

export const getMarketDepthIdActionFail = (error) => ({
  type: actionLabels.GET_MARKET_DEPTH_FAIL,
  payload: error,
});

export const CatalogColumnConfigAction = (CatalogColumnConfigId) => {
  return {
    type: actionLabels.COLUMN_CONFIG_TABLE,
    payload: CatalogColumnConfigId,
  };
};

export const CatalogColumnConfigActionSuccess = (CatalogColumnConfigData) => {
  return {
    type: actionLabels.COLUMN_CONFIG_TABLE_SUCCES,
    payload: CatalogColumnConfigData,
  };
};

export const CatalogColumnConfigActionFail = (error) => ({
  type: actionLabels.COLUMN_CONFIG_TABLE_FAIL,
  payload: error,
});

export const UserwiseCloumnConfigAction = (UserwiseCloumnId) => {
  return {
    type: actionLabels.USERWISE_CONFIG_TABLE,
    payload: UserwiseCloumnId,
  };
};

export const UserwiseCloumnConfigActionSuccess = (UserwiseCloumnData) => {
  return {
    type: actionLabels.USERWISE_CONFIG_TABLE_SUCCES,
    payload: UserwiseCloumnData,
  };
};

export const UserwiseCloumnConfigActionFail = (error) => ({
  type: actionLabels.USERWISE_CONFIG_TABLE_FAIL,
  payload: error,
});

export const DefaultCloumnConfigAction = (DefaultCloumnId) => {
  return {
    type: actionLabels.DEFULT_CONFIG_TABLE,
    payload: DefaultCloumnId,
  };
};

export const DefaultCloumnConfigActionSuccess = (DefaultCloumnData) => {
  return {
    type: actionLabels.DEFULT_CONFIG_TABLE_SUCCES,
    payload: DefaultCloumnData,
  };
};

export const DefaultCloumnConfigActionFail = (error) => ({
  type: actionLabels.DEFULT_CONFIG_TABLE_FAIL,
  payload: error,
});

export const UserwiseCloumnConfigStatus = (data) => {
  return {
    type: actionLabels.USERWISE_CATALOG_STUTAS,
    payload: { data: data },
  };
};
export const DefaultCloumnConfigStutas = (data) => {
  return {
    type: actionLabels.DEFUALT_CATALOG_STUTAS,
    payload: { data: data },
  };
};

export const GetGroupCodeAction = (GroupCodeId) => {
  return {
    type: actionLabels.GROUP_CODE_TABLE,
    payload: GroupCodeId,
  };
};

export const GetGroupCodeActionSuccess = (GroupCodeData) => {
  return {
    type: actionLabels.GROUP_CODE_TABLE_SUCCES,
    payload: GroupCodeData,
  };
};

export const GetGroupCodeActionFail = (error) => ({
  type: actionLabels.GROUP_CODE_TABLE_FAIL,
  payload: error,
});

export const addvaluationAction = (valueId) => {
  return {
    type: actionLabels.ADD_VALUATION_ACTION,
    payload: valueId,
  };
};

export const addvaluationSuccess = (valueData) => {
  return {
    type: actionLabels.ADD_VALUATION_ACTION_SUCCES,
    payload: valueData,
  };
};

export const addvaluationActionFail = (error) => ({
  type: actionLabels.ADD_VALUATION_ACTION_FAIL,
  payload: error,
});

export const addvaluationStatus = (data) => {
  return {
    type: actionLabels.VALUE_STUTAS,
    payload: { data: data },
  };
};

export const isRpButtonClickedTrue = () => ({
  type: actionLabels.IS_RP_BUTTON_CLICKED_TRUE
})

export const isRpButtonClikedFalse = () => ({
  type: actionLabels.IS_RP_BUTTON_CLICKED_FALSE,
});
